/**
 * CLOSET: 2点以上購入で アンダーウェアギフト 自動追加（Gift With Purchase）
 * -----------------------------------------------------------------------------
 * 仕様:
 *   - ギフト および ギフトオプション（ショッパー等）を除いた合計数量が THRESHOLD 以上 → ギフト(¥0)を1点自動追加
 *   - 2点未満に減ったら 自動削除
 *   - ギフトは常に数量1（増減不可）。カート上で数量変更/削除できないようロック
 *   - サイズはカートには出さず、当店が注文内容に合わせて選定（明細プロパティで明記）
 *
 * 期間: 2026-08-10 〜 2026-08-20（GWP_START / GWP_END で制御）。期間外は何もしない＋既存ギフトを掃除。
 *
 * 依存: Focalテーマの 'cart:updated' / 'cart:refresh' イベント（custom.js 参照）
 */
(function () {
  'use strict';

  var GIFT_VARIANT_ID = 50087661994224;           // アンダーウェアギフト の Default Title variant
  var GIFT_HANDLE = 'underwear-gift';
  var THRESHOLD = 2;                                // カウント対象の合計数量がこの数以上で付与

  // 点数カウントから除外する商品（ギフトオプション類）
  //   CLOSET Original Shopping Bag: handle gift-wrap-option / variant 47781286379760 / product_type gift-option
  var EXCLUDED_VARIANT_IDS = [47781286379760];
  var EXCLUDED_HANDLES = ['gift-wrap-option'];
  var EXCLUDED_PRODUCT_TYPES = ['gift-option'];     // 今後ギフトボックス等が増えてもこの type なら自動で除外
  var GWP_START = new Date('2026-08-10T00:00:00+09:00');
  var GWP_END = new Date('2026-08-20T23:59:59+09:00');
  var GIFT_PROPS = {
    '内容': 'サイズはご注文内容に合わせて当店が選定します',
    '_gwp': '2026-08 GWP'                           // 先頭_で顧客側は非表示・管理画面/注文には残る
  };

  var busy = false;
  var pending = false;

  function isActivePeriod() {
    try {
      var now = new Date();
      return now >= GWP_START && now <= GWP_END;
    } catch (e) { return false; }
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  // 点数カウントの対象か（ギフト本体・ギフトオプションは対象外）
  function isCountable(it) {
    if (it.variant_id === GIFT_VARIANT_ID) return false;
    if (EXCLUDED_VARIANT_IDS.indexOf(it.variant_id) !== -1) return false;
    if (it.handle && EXCLUDED_HANDLES.indexOf(it.handle) !== -1) return false;
    if (it.product_type && EXCLUDED_PRODUCT_TYPES.indexOf(it.product_type) !== -1) return false;
    return true;
  }

  function nonGiftQty(cart) {
    return cart.items.reduce(function (sum, it) {
      return isCountable(it) ? sum + it.quantity : sum;
    }, 0);
  }

  function giftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === GIFT_VARIANT_ID) return cart.items[i];
    }
    return null;
  }

  function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: GIFT_PROPS }] })
    });
  }

  function setGiftQty(qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(GIFT_VARIANT_ID), quantity: qty })
    });
  }

  function refreshCartUI() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  // カートを望ましい状態へ収束させる（冪等・ループしない）
  function reconcile() {
    if (busy) { pending = true; return; }
    busy = true;
    getCart().then(function (cart) {
      var qty = nonGiftQty(cart);
      var gift = giftLine(cart);
      var qualifies = isActivePeriod() && qty >= THRESHOLD;
      var action = null;

      if (qualifies && !gift) action = addGift();
      else if (qualifies && gift && gift.quantity !== 1) action = setGiftQty(1);
      else if (!qualifies && gift) action = setGiftQty(0);

      if (action) {
        return action.then(function () { refreshCartUI(); });
      }
    }).catch(function () { /* 通信失敗時は次のイベントで再試行 */ })
      .then(function () {
        busy = false;
        lockGiftLines();
        if (pending) { pending = false; reconcile(); }
      });
  }

  // ---- ギフト行のロック（数量変更・削除の非表示＋ラベル付与） ----
  function lockGiftLines() {
    var links = document.querySelectorAll('a[href*="/products/' + GIFT_HANDLE + '"]');
    for (var i = 0; i < links.length; i++) {
      var row = links[i].closest('.line-item');
      if (!row || row.classList.contains('gwp-gift-line')) continue;
      row.classList.add('gwp-gift-line');
    }
  }

  var lockScheduled = false;
  function scheduleLock() {
    if (lockScheduled) return;
    lockScheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      lockScheduled = false;
      lockGiftLines();
    }, 16);
  }

  function init() {
    // カート内容が変わるたびに収束
    document.addEventListener('cart:updated', reconcile);
    // ミニカート/カートページの再描画のたびにギフト行をロック
    var mo = new MutationObserver(scheduleLock);
    mo.observe(document.body, { childList: true, subtree: true });
    // 初回ロード時の状態合わせ
    reconcile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
